import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import View from 'components/ui/view';
import Text from 'components/ui/text';

export default function OrderHeading({ orderDate, wasCanceled, wasReturned }) {
  return (
    <Fragment>
      <View margin="xxs">
        <Text title tag="h2" weight="med" size="md" margin="none">
          {moment(orderDate).format('MMMM D, YYYY')}
        </Text>
      </View>
      <View margin="sm">
        {wasCanceled || wasReturned ? (
          <Text title error size="xs" weight="bold">
            {wasCanceled ? 'Canceled' : 'Returned'}
          </Text>
        ) : (
          <Text title secondary size="xs" weight="med">
            Delivered {moment(orderDate).format('MMMM D, YYYY h:mm A')}
          </Text>
        )}
      </View>
      <View margin="xs">
        <Link to="/orders" className="link-text text-secondary">
          View All Orders
        </Link>
      </View>
    </Fragment>
  );
}
